import React, {useState} from "react";
import "./QuickStatsModal.scss";

import { ReactComponent as CopyIcon } from "static/icons/copy-icon.svg";
import { ReactComponent as ArrowImg } from "static/icons/arrow-gray.svg";

const QuickStatsTable = ({ table, data, headerData, rowData, footerData, handleCopyCellClicked }) => {

  const [isOpenTable, setOpenTable] = useState(null);

  const managerTable = () => {
    setOpenTable(!isOpenTable);
  }

  return (
    <div className="quick-stats-modal__table">
              {
                data.length > 1 &&
                <div className="quick-stats-modal__table_name" onClick={managerTable}>
                  <div className="quick-stats-modal__table_name-background" style={{backgroundColor: table.color}}></div>
                  <div className="quick-stats-modal__table_name-color" style={{backgroundColor: table.color}}></div>
                  <div className="quick-stats-modal__table_name-text">{table.name}</div>
                  <ArrowImg className={`quick-stats-modal__table_name-img ${isOpenTable ? 'quick-stats-modal__table_name-img-open' : ""}`}/>
                </div>
              }
              <div className={`${isOpenTable || data.length === 1 ? "quick-stats-modal__table_open" : "quick-stats-modal__table_close"}`}>
                <div className="quick-stats-modal__table_header">
                  {headerData(table.info).map((item, index) => {
                    if (item.name === 'copy') {
                      return (
                        <div
                          key={`header-${index}`}
                          className="quick-stats-modal__table_header-item quick-stats-modal__table_header-item-copy"
                        />
                      );
                    } else {
                      return (
                        <div
                          key={`header-${index}`}
                          className="quick-stats-modal__table_header-item"
                        >
                          {item.value}
                        </div>
                      );
                    }
                  })}
                </div>
                <div className="quick-stats-modal__table_body">

                  {rowData(table.info).map((item, index) => {
                    const rowArr = [];

                    for (let key in item) {
                      rowArr.push(item[key]);
                    }

                    return (
                      <div
                        key={`rows-${index}`}
                        className="quick-stats-modal__table_row"
                      >
                        {rowArr.map((cell, i) => {
                          const handleCopyClick = () => {
                            handleCopyCellClicked(rowArr);
                          };

                          if (cell.name === 'copy') {
                            return (
                              <div
                                key={`row-${index}-${i}`}
                                className="quick-stats-modal__table_row-item quick-stats-modal__table_row-item-copy"
                                onClick={handleCopyClick}
                              >
                                <div className="quick-stats-modal__table_copy-icon-container">
                                  <CopyIcon className="quick-stats-modal__table_copy-icon" />
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <div
                                key={`row-${index}-${i}`}
                                className="quick-stats-modal__table_row-item"
                              >
                                <div className="quick-stats-modal__table_row-item-unit-container">
                                  <span>{cell.visibleValue}</span>

                                  <div className="quick-stats-modal__table_row-item-unit-container">
                                    &nbsp;
                                    {cell?.unit &&
                                      <span className="quick-stats-modal__table_row-item-unit">
                                  {cell?.unit}
                                </span>
                                    }

                                    {cell?.unitDegree &&
                                      <span className="quick-stats-modal__table_row-item-unit-degree">
                                  {cell?.unitDegree}
                                </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                    );
                  })}
                </div>
                <div className="quick-stats-modal__table_footer">
                  {footerData(table.info).map((item, index) => {
                    const handleCopyClick = () => {
                      handleCopyCellClicked(footerData);
                    };

                    if (item.name === 'copy') {
                      return (
                        <div
                          key={`footer-${index}`}
                          className="quick-stats-modal__table_footer-item quick-stats-modal__table_footer-item-copy"
                          onClick={handleCopyClick}
                        >
                          <div className="quick-stats-modal__table_copy-icon-container">
                            <CopyIcon className="quick-stats-modal__table_copy-icon" />
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          key={`footer-${index}`}
                          className="quick-stats-modal__table_footer-item"
                        >
                          <div className="quick-stats-modal__table_row-item-unit-container">
                            <span>{item.visibleValue}</span>

                            {
                              item.value !== "Total" &&
                              <div className="quick-stats-modal__table_row-item-unit-container">
                                &nbsp;
                                {item?.unit &&
                                  <span className="quick-stats-modal__table_row-item-unit">
                            {item?.unit}
                          </span>
                                }

                                {item?.unitDegree &&
                                  <span className="quick-stats-modal__table_row-item-unit-degree">
                            {item?.unitDegree}
                          </span>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
  );
};

export default QuickStatsTable;